<template>
  <div class="row">
    <div class="col-5 px-0">
      <b-list-group>
        <b-list-group-item
          v-for="(workTypeGroup, key) in workTypes"
          :key="key.replace(/\s/g, '')"
          v-b-toggle="'sub-'+key.replace(/\s/g, '')"
          button
          :class="['py-2', 'pr-2']"
          role="tab"
          :active="collapseStates['sub-'+key.replace(/\s/g, '')]"
          @click="$emit('click')"
        >
          {{ key }} ({{ countSelected(key) }} of {{ workTypeGroup.length }})
        </b-list-group-item>
      </b-list-group>
    </div>
    <div class="col-7 worktype__selection px-0">
      <div v-if="displayPlaceholder" class="col-12 d-flex h-100 justify-content-center align-items-center">
        <div class="position-relative worktype-placeholder">
          <h2 class="h4 font-italic font-weight-light text-center">
            {{ $t('Select a category to show lead types available') }}
          </h2>
        </div>
      </div>
      <b-collapse
        v-for="(workTypeGroup, key) in workTypes"
        :id="'sub-'+key.replace(/\s/g, '')"
        :ref="'workTypeCategory' + key"
        :key="'sub-'+key.replace(/\s/g, '')"
        v-model="collapseStates['sub-'+key.replace(/\s/g, '')]"
        :accordion="'work-type-list'"
      >
        <b-list-group>
          <div class="d-flex flex-column w-100 align-items-start">
            <b-list-group-item
              class="add-all p-2 font-weight-bold"
            >
              <b-button variant="link" class="py-0" @click="add(workTypeGroup)">
                {{ $t('Add all') }}
              </b-button>
            </b-list-group-item>
            <div class="worktype-list d-flex flex-column">
              <b-list-group-item
                v-for="(wt, wtKey) in workTypeGroup"
                :key="wtKey"
                button
                :class="['p-2', (isSelected(wt.id)) ? 'font-weight-light': 'font-weight-bold']"
                @click.prevent.stop="toggle(wt, isSelected(wt.id) ? '' : 'add')"
              >
                <b-checkbox :checked="isSelected(wt.id)" class="forced-pointer">
                  {{ getDescriptionTranslation(wt) }}
                </b-checkbox>
              </b-list-group-item>
            </div>
          </div>
        </b-list-group>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import notification from "@/imports/mixins/notification";
import workTypeTranslation from "@/imports/mixins/workTypeTranslation";
import company from "@/imports/mixins/company";

export default {
  name: "WorkTypeList",
  mixins: [notification, workTypeTranslation, company],
  props: ['workTypes', 'value'],
  data: function() {
    return {
      collapseStates: {},
      displayPlaceholder: true,
    }
  },
  methods: {
    isSelected: function(workTypeId) {
      return this.value.find(workType => workType.id === workTypeId) !== undefined;
    },
    add: function(workType){
      if (Array.isArray(workType)) {
        this.notify(
          this.$bvToast,
          this.$t('Lead type group {worktypeCategoryName} added', {worktypeCategoryName: workType[0].category.name}),
          null,
          'success'
        );
        this.$emit('input', [...workType.filter(wt => !this.isSelected(wt.id)), ...this.value]);
      } else {
        this.notify(
          this.$bvToast,
          this.$t('Lead type added', {workTypeDescription: workType.description}),
          null,
          'success'
        );
        this.$emit('input', [workType, ...this.value]);
      }
    },
    remove: function(workType){
      this.notify(
        this.$bvToast,
        `Lead type "${workType.description}" removed`,
        null,
        'success'
      );
      this.$emit('input', this.value.filter(wt => wt.id !== workType.id));
    },
    toggle: function(workType, action) {
      this.$emit('click');
      if(action === 'add') {
        return this.add(workType);
      }
      return this.remove(workType);
    },
    countSelected(category) {
      let count = 0;
      this.value.forEach(wt => {
        if (wt.category.name === category) {
          count++;
        }
      });
      return count;
    },
  },
  created: function() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (['sub-Boilers', 'sub-HeatingEngineers', 'sub-RenewableEnergyInstallers', 'sub-Solar'].includes(collapseId)
        && isJustShown === true
      ) {
        this.displayPlaceholder = false;
      }
    })
  },
  beforeDestroy: function() {
    this.$root.$off('bv::collapse::state');
  }
}
</script>

<style scoped lang="scss">

.card {
  [role=tab] {
    @include font-size($font-size-14);
  }
}

.worktype__selection {
  border-left: 1px solid $border-color;
  .list-group-item {
    background-color: transparent;
  }
}

.list-group {
  border-radius: 0;
  .list-group-item {
    border: 0;
  }
  .list-group-item-action:focus {
    transition: $transition-base;
    background: $coverage-worktype-list-accent;
    font-weight: 700;
    outline: none;
  }
}

.list-group-item {
  color: $theme-primary;
  border-radius: 0;
  padding-left: 15px;
  @include font-size($font-size-14);

  &.collapsed {
    border: 1px solid transparent;

    @include media-breakpoint-down(xl) {
      padding-left: 10px;
    }
  }

  &.not-collapsed {
    transition: $transition-base;
    background: $coverage-worktype-list-accent;
    border: 1px solid $coverage-worktype-list-accent;
    border-right: 1px solid $coverage-worktype-list-accent;
    font-weight: 700;
    color: $theme-primary;

    @include media-breakpoint-down(xl) {
      padding-left: 10px;
    }
  }

  &:hover{
    background: $body-bg;
    opacity: 1;
    transition: $transition-base;
  }

  + .list-group-item.active {
    margin-top: 0;

    @include media-breakpoint-down(xl) {
      padding-left: 10px;
    }
  }
}

.add-all {
  position: relative;

  &:before {
    background-color: $border-color;
    content: "\200C";
    position: absolute;
    bottom: 0;
    height: 1px;
    width: calc(100% - 1rem);
  }

  .btn {
    text-decoration: underline;
  }
}

.add-all,
.worktype-list {
  width: 100%;
}
.forced-pointer {
  ::v-deep .custom-control-label {
    cursor:pointer !important;
  }
}

</style>
